import { fetchToken } from "../../common/FetchCookie";
import {
    BASE_URL,
    CANDIDATE,
    CANDIDATE_BASIC_DETAILS,
    CANDIDATE_BASIC_DETAILS_PARAM,
    CANDIDATE_DETAILS_BY_PARAM,
    CANDIDATE_PROFILE_PHOTO,
    CANDIDATE_RESUME,
} from "../../common/URLs";

// Add this to your existing API file or create a new one
export const fetchBasicDetailsBySingleParam = async () => {
    try {
        const token = await fetchToken();
        const response = await fetch(
            `${BASE_URL}/${CANDIDATE}/${CANDIDATE_DETAILS_BY_PARAM}?${CANDIDATE_BASIC_DETAILS_PARAM}`,
            {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                    accept: "application/json",
                },
            }
        );
        const data = await response.json();
        return data.response;
    } catch (error) {
        console.log("error in fetching basic details by single param", error);
        throw error;
    }
};

const API_URL = `${BASE_URL}/${CANDIDATE}/${CANDIDATE_BASIC_DETAILS}`;

export const updateCandidateDetails = async (uuid, candidateData) => {
    try {
        const token = await fetchToken();
        const response = await fetch(`${API_URL}/${uuid}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(candidateData),
        });
        // console.log("cand", candidateData);

        if (!response.ok) {
            throw new Error("Error updating candidate : " + response.statusText);
        }

        return await response.json();
    } catch (error) {
        throw new Error("Error updating candidate : " + error.message);
    }
};

// api.js (API Call)

export const addCandidateProfile = async (formData) => {
    try {
        // console.log("api call", formData)
        const token = await fetchToken();
        const response = await fetch(
            `${BASE_URL}/${CANDIDATE}/${CANDIDATE_PROFILE_PHOTO}`,
            {
                method: "POST",
                body: formData,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        if (!response.ok) {
            throw new Error("Failed to upload logo");
        }

        const data = await response.json();
        return data; // Return the uploaded logo data (e.g., URL, ID, etc.)
    } catch (error) {
        throw new Error(error.message);
    }
};

export const addCandidateResume = async (formData) => {
    try {
        // console.log("api call", formData)
        const token = await fetchToken();
        const response = await fetch(
            `${BASE_URL}/${CANDIDATE}/${CANDIDATE_RESUME}`,
            {
                method: "POST",
                body: formData,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        if (!response.ok) {
            throw new Error("Failed to upload logo");
        }

        const data = await response.json();
        return data; // Return the uploaded logo data (e.g., URL, ID, etc.)
    } catch (error) {
        throw new Error(error.message);
    }
};
